//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "school-ranking",
  props: {
    rankingList: {
      type: Array,
      default:[]
    },
    GetMobelType: {
      type: Object,
      default:[]
    }
  },
  data () {
    return {
      imgHeight : 0,
      version: 1,
    }
  },
  mounted () {
    let width = window.screen.width
    this.imgHeight = (width - 64) * 0.32
  },
}



// WEBPACK FOOTER //
// ./src/components/common/schoolRanking.vue